import { FC, useContext} from "react";
import { BoardContext } from "../../../../context";
import { useSound } from "../../../../hooks";

interface SwapButtonProps {
    clickHandler(): void;
    isThisReturnButton?: boolean;
    isThisJokerButton?: boolean;
}

const SwapButton: FC<SwapButtonProps> = (props) => {
    const { clickHandler, isThisReturnButton, isThisJokerButton } = props;
    const { jokerClicked, setJokerClicked } = useContext(BoardContext);
    const {playSound} = useSound();

    let buttonStyle : string =  "exchange_button";
    let buttonIconStyle : string ="exchange_button__icon";

    if (isThisReturnButton) {
        buttonStyle = "return_button";
        buttonIconStyle = "return_button__icon";
    }

    if (isThisJokerButton) {
        buttonStyle = "joker_button";
        buttonIconStyle = "joker_button__icon";
    }

    const handleClick = () => {
        if(isThisJokerButton && !jokerClicked){
            setJokerClicked(true);
            clickHandler();
            playSound("/sounds/LightClick.mp3");
        }
        if(!isThisJokerButton){
            setJokerClicked(false);
            clickHandler();
            playSound("/sounds/LightClick.mp3");
        }
    }

    return (
        <div className={buttonStyle} onClick={handleClick}>
            <div className={buttonIconStyle}/>
        </div>
    );
};

export default SwapButton;

